export default function setCookie(name, value) {
  const domain = (window.location.hostname || '').replace('www', '');
  value = encodeURIComponent(value);
  document.cookie = `${name}=${value}; domain=${domain}; SameSite=lax; path=/; Secure; max-age=2592000`;
}
